export const recommendOptions = {
  birthday: {
    label: "生日",
    defaultEngravingContent: {
      commemorativeMedalGreetingsAndName: "恭祝王小明誕聖",
      commemorativeMedalGreetingMessage: "生日快樂",
      commemorativeMedalGreetingImageOption: "cake",
      commemorativeMedalGreetingImageCustom: "",
      commemorativeMedalSenderName: "王大明 2025.09.09",
    },
  },
  longevityCelebration: {
    label: "祝壽",
    defaultEngravingContent: {
      commemorativeMedalGreetingsAndName: "恭祝王小明華誕",
      commemorativeMedalGreetingMessage: "壽比南山",
      commemorativeMedalGreetingImageOption: "crane",
      commemorativeMedalGreetingImageCustom: "",
      commemorativeMedalSenderName: "王大明 2025.09.09",
    },
  },
  housewarming: {
    label: "喬遷",
    defaultEngravingContent: {
      commemorativeMedalGreetingsAndName: "恭祝王小明喬遷",
      commemorativeMedalGreetingMessage: "新居落成",
      commemorativeMedalGreetingImageOption: "house",
      commemorativeMedalGreetingImageCustom: "",
      commemorativeMedalSenderName: "王大明 2025.09.09",
    },
  },
  victory: {
    label: "勝利",
    defaultEngravingContent: {
      commemorativeMedalGreetingsAndName: "恭祝王小明勝利",
      commemorativeMedalGreetingMessage: "出類拔萃",
      commemorativeMedalGreetingImageOption: "trophy",
      commemorativeMedalGreetingImageCustom: "",
      commemorativeMedalSenderName: "王大明 2025.09.09",
    },
  },
  promotion: {
    label: "升官",
    defaultEngravingContent: {
      commemorativeMedalGreetingsAndName: "恭祝王小明升官",
      commemorativeMedalGreetingMessage: "青雲直上",
      commemorativeMedalGreetingImageOption: "eagle",
      commemorativeMedalGreetingImageCustom: "",
      commemorativeMedalSenderName: "王大明 2025.09.09",
    },
  },
};
